import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

interface CognitiveData {
  overall_percentile: number;
  verbal_score: number;
  numerical_score: number;
  abstract_score: number;
}

export const useUserCognitiveData = () => {
  const [cognitiveData, setCognitiveData] = useState<CognitiveData | null>(null);
  const [loadingCognitive, setLoadingCognitive] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const fetchUserCognitiveData = async () => {
      if (!user?.email) return;
      
      setLoadingCognitive(true);
      try {
        const { data, error } = await supabase
          .from('cognitive_submissions')
          .select('overall_percentile, verbal_score, numerical_score, abstract_score')
          .eq('user_id', user.id)
          .order('created_at', { ascending: false })
          .limit(1)
          .maybeSingle();

        if (error) {
          console.error('Error fetching user cognitive data:', error);
        } else if (data) {
          setCognitiveData(data);
        }
      } catch (error) {
        console.error('Error fetching user cognitive data:', error);
      } finally {
        setLoadingCognitive(false);
      }
    };

    fetchUserCognitiveData();
  }, [user?.id, user?.email]);

  return { cognitiveData, loadingCognitive };
};